import Swal from "sweetalert2";
import { getInstance } from "./baseapi";

const dataToken = localStorage.getItem("tokenBackoffice");
const instance = getInstance();

// ----------------------------------------------- Office----------------------------------------------------
export const getBusOffice = async (queryparams) => {
    try{
        const headers = {
            Authorization: "Bearer " + dataToken,
          };
        const response = await instance.get(`/api/mgr/business/office`, {
            headers:headers,
            params: {...queryparams}
        })
        if (response.status === 200) {
            return response;
        } else {
            return null;
        }
    }catch(error) {
        Swal.fire({
            icon: "error",
            title: error,
            confirmButtonText: "OK",
        }).then((result) => {});
    }
};

export const getBusOfficeByID = async (id) => {
    try {
        const headers = {
            Authorization: "Bearer " + dataToken,
        };
        const response = await instance.get(`/api/mgr/business/office${id}`, {
            headers: headers,
        });
        if (response.status === 200) {
            return await response;
        } else {
            return null;
        }
    } catch (error) {
        Swal.fire({
            icon: "error",
            title: error,
            confirmButtonText: "OK",
        }).then((result) => {});
    }
};

export const createAndUpdateBusOfficeByID = async (id, body) => {
    try {
        const formData = new FormData()
        formData.append('type', body.type)
        formData.append('content_type', body.content_type)
        formData.append('content_sub_type', body.content_sub_type)
        formData.append('vr_link', body.vr_link)
        formData.append('description_en', body.description_en)
        formData.append('description_th', body.description_th)
        formData.append('specification_en', body.specification_en)
        formData.append('specification_th', body.specification_th)
        formData.append('facilities_en', body.facilities_en)
        formData.append('facilities_th', body.facilities_th)
        formData.append('email_contact', body.email_contact)
        formData.append('email_cc', body.email_cc)

        if (body.spec_img.length > 0) {
            if(body.spec_img[0].file?.file){
                const blob = new Blob([body.spec_img[0].file?.file], { type: body.spec_img[0].file?.file.type });
                const parts = body.spec_img[0].file?.src[0].split('/')
                const fileName = parts[parts.length - 1];
                const currentTime = new Date();
                const file = new File([blob], fileName, {
                    type: body.spec_img[0].file?.file.type,
                    lastModified: currentTime.getTime(),
                    lastModifiedDate: currentTime,
                    size: body.spec_img[0].file.size
                });

                formData.append('spec_img', file)
            }
            else{
                formData.append('spec_img', body.spec_img[0].file)
            }
        }
        else{
            formData.append('spec_img', null)
        }

        if (body.fac_img.length > 0) {
            if(body.fac_img[0].file?.file){
                const blob = new Blob([body.fac_img[0].file?.file], { type: body.fac_img[0].file?.file.type });
                const parts = body.fac_img[0].file?.src[0].split('/')
                const fileName = parts[parts.length - 1];
                const currentTime = new Date();
                const file = new File([blob], fileName, {
                    type: body.fac_img[0].file?.file.type,
                    lastModified: currentTime.getTime(),
                    lastModifiedDate: currentTime,
                    size: body.fac_img[0].file.size
                });

                formData.append('fac_img', file)
            }
            else{
                formData.append('fac_img', body.fac_img[0].file)
            }
        }
        else{
            formData.append('fac_img', null)
        }

        if (body.gallery.length > 0) {
            body.gallery.forEach((galleryItem, index) => {
                if (galleryItem.file?.file) {
                    const blob = new Blob([galleryItem.file.file], { type: galleryItem.file.file.type });
                    const parts = galleryItem.file.src[0].split('/');
                    const fileName = parts[parts.length - 1];
                    const currentTime = new Date();
                    const file = new File([blob], fileName, {
                        type: galleryItem.file.file.type,
                        lastModified: currentTime.getTime(),
                        lastModifiedDate: currentTime,
                        size: galleryItem.file.size
                    });
        
                    formData.append(`gallery`, file);
                } else {
                    formData.append(`gallery`, galleryItem.file);
                }
            });
        }
        else{
            formData.append('gallery', null)
        }

        if (body.plan_img.length > 0) {
            body.plan_img.forEach((planItem, index) => {
                if (planItem.file?.file) {
                    const blob = new Blob([planItem.file.file], { type: planItem.file.file.type });
                    const parts = planItem.file.src[0].split('/');
                    const fileName = parts[parts.length - 1];
                    const currentTime = new Date();
                    const file = new File([blob], fileName, {
                        type: planItem.file.file.type,
                        lastModified: currentTime.getTime(),
                        lastModifiedDate: currentTime,
                        size: planItem.file.size
                    });
        
                    formData.append(`plan_img`, file);
                } else {
                    formData.append(`plan_img`, planItem.file);
                }
            });
        }
        else{
            formData.append('plan_img', null)
        }

        const headers = {
            Authorization: "Bearer " + dataToken,
        };
        let response = null 
        if(id){
            response = await instance.put(`/api/mgr/business/office/${id}`, formData, {
                headers: headers,
            });
        }else{
            response = await instance.post(`/api/mgr/business/office`, formData, {
                headers: headers,
            });
        }
        return response;

    } catch (error) {
        Swal.fire({
            icon: "error",
            title: error,
            confirmButtonText: "OK",
        }).then((result) => {});
    }
};

// ----------------------------------------------- Retail ----------------------------------------------------
export const getBusRetail = async (queryparams) => {
    try{
        const headers = {
            Authorization: "Bearer " + dataToken,
        };
        const response = await instance.get(`/api/mgr/business/retail`, {
            headers:headers,
            params: {...queryparams}
        })
        if (response.status === 200) {
            return response;
        } else {
            return null;
        }
    }catch(error) {
        Swal.fire({
            icon: "error",
            title: error,
            confirmButtonText: "OK",
        }).then((result) => {});
    }
};

export const createAndUpdateBusRetail = async (id, body) => {
    try {
        const formData = new FormData()
        formData.append('vr_link', body.vr_link)
        formData.append('description_en', body.description_en)
        formData.append('description_th', body.description_th)
        formData.append('leaflet_en', body.leaflet_en)
        formData.append('leaflet_th', body.leaflet_th)
        formData.append('email_contact', body.email_contact)
        formData.append('email_cc', body.email_cc)
        formData.append('event_space_floor_g_description_en', body.event_space_floor_g_description_en)
        formData.append('event_space_floor_g_description_th', body.event_space_floor_g_description_th)
        formData.append('event_space_f2_description_en', body.event_space_f2_description_en)
        formData.append('event_space_f2_description_th', body.event_space_f2_description_th)

        if (body.gallery.length > 0) {
            body.gallery.forEach((galleryItem, index) => {
                if (galleryItem.file?.file) {
                    const blob = new Blob([galleryItem.file.file], { type: galleryItem.file.file.type });
                    const parts = galleryItem.file.src[0].split('/');
                    const fileName = parts[parts.length - 1];
                    const currentTime = new Date();
                    const file = new File([blob], fileName, {
                        type: galleryItem.file.file.type,
                        lastModified: currentTime.getTime(),
                        lastModifiedDate: currentTime,
                        size: galleryItem.file.size
                    });
        
                    formData.append(`gallery`, file);
                } else {
                    formData.append(`gallery`, galleryItem.file);
                }
            });
        }
        else{
            formData.append('gallery', null)
        }

        if (body.imgs_fg.length > 0) {
            body.imgs_fg.forEach((imgsFGItem, index) => {
                if (imgsFGItem.file?.file) {
                    const blob = new Blob([imgsFGItem.file.file], { type: imgsFGItem.file.file.type });
                    const parts = imgsFGItem.file.src[0].split('/');
                    const fileName = parts[parts.length - 1];
                    const currentTime = new Date();
                    const file = new File([blob], fileName, {
                        type: imgsFGItem.file.file.type,
                        lastModified: currentTime.getTime(),
                        lastModifiedDate: currentTime,
                        size: imgsFGItem.file.size
                    });
        
                    formData.append(`imgs_fg`, file);
                } else {
                    formData.append(`imgs_fg`, imgsFGItem.file);
                }
            });
        }
        else{
            formData.append('imgs_fg', null)
        }

        if (body.imgs_f2.length > 0) {
            body.imgs_f2.forEach((imgsF2Item, index) => {
                if (imgsF2Item.file?.file) {
                    const blob = new Blob([imgsF2Item.file.file], { type: imgsF2Item.file.file.type });
                    const parts = imgsF2Item.file.src[0].split('/');
                    const fileName = parts[parts.length - 1];
                    const currentTime = new Date();
                    const file = new File([blob], fileName, {
                        type: imgsF2Item.file.file.type,
                        lastModified: currentTime.getTime(),
                        lastModifiedDate: currentTime,
                        size: imgsF2Item.file.size
                    });
        
                    formData.append(`imgs_f2`, file);
                } else {
                    formData.append(`imgs_f2`, imgsF2Item.file);
                }
            });
        }
        else{
            formData.append('imgs_f2', null)
        }

        if (body.imgs_f_leaflet.length > 0) {
            body.imgs_f_leaflet.forEach((imgsLeafletItem, index) => {
                if (imgsLeafletItem.file?.file) {
                    const blob = new Blob([imgsLeafletItem.file.file], { type: imgsLeafletItem.file.file.type });
                    const parts = imgsLeafletItem.file.src[0].split('/');
                    const fileName = parts[parts.length - 1];
                    const currentTime = new Date();
                    const file = new File([blob], fileName, {
                        type: imgsLeafletItem.file.file.type,
                        lastModified: currentTime.getTime(),
                        lastModifiedDate: currentTime,
                        size: imgsLeafletItem.file.size
                    });
        
                    formData.append(`imgs_f_leaflet`, file);
                } else {
                    formData.append(`imgs_f_leaflet`, imgsLeafletItem.file);
                }
            });
        }
        else{
            formData.append('imgs_f_leaflet', null)
        }

        const headers = {
            Authorization: "Bearer " + dataToken,
        };
        let response = null 
        if(id){
            response = await instance.put(`/api/mgr/business/retail`, formData, {
                headers: headers,
            });
        }else{
            response = await instance.post(`/api/mgr/business/retail`, formData, {
                headers: headers,
            });
        }
        return response;

    } catch (error) {
        Swal.fire({
            icon: "error",
            title: error,
            confirmButtonText: "OK",
        }).then((result) => {});
    }
};

export const getBusRetailDir = async (queryparams) => {
    try{
        const headers = {
            Authorization: "Bearer " + dataToken,
        };
        const response = await instance.get(`/api/mgr/business/retail/directory`, {
            headers:headers,
            params: {...queryparams}
        })
        if (response.status === 200) {
            return response;
        } else {
            return null;
        }
    }catch(error) {
        Swal.fire({
            icon: "error",
            title: error,
            confirmButtonText: "OK",
        }).then((result) => {});
    }
};

export const getBusRetailDirById = async (id, queryparams) => {
    try{
        const headers = {
            Authorization: "Bearer " + dataToken,
        };
        const response = await instance.get(`/api/mgr/business/retail/directory/${id}`, {
            headers:headers,
            params: {...queryparams}
        })
        if (response.status === 200) {
            return response;
        } else {
            return null;
        }
    }catch(error) {
        Swal.fire({
            icon: "error",
            title: error,
            confirmButtonText: "OK",
        }).then((result) => {});
    }
};

export const createBusRetailDir = async (body) => {
    try {
     
        
        const formData = new FormData()
        formData.append('name_en', body.name_en)
        formData.append('name_th', body.name_th)
        formData.append('description_en', body.description_en)
        formData.append('description_th', body.description_th)
        formData.append('address_en', body.address_en)
        formData.append('address_th', body.address_th)
        formData.append('active', body.active)
        formData.append('floor', body.floor)
        formData.append('room_no', body.room_no)
        formData.append('open_time', body.open_time)
        formData.append('tel', body.tel)

        if (body.gallery.length > 0) {
            for(let i = 0; i <body.gallery.length; i++) {
                if(body.gallery[i].file?.file){
                    const blob = new Blob([body.gallery[i].file?.file], { type: body.gallery[i].file?.file.type });
                    const parts = body.gallery[i].file?.src[0].split('/')
                    const fileName = parts[parts.length - 1];
                    const currentTime = new Date();
                    const file = new File([blob], fileName, {
                        type: body.gallery[i].file?.file.type,
                        lastModified: currentTime.getTime(),
                        lastModifiedDate: currentTime,
                        size: body.gallery[i].file.size
                    });
    
                    formData.append('gallery', file)
                }else{
                    formData.append('gallery', body.gallery[i].file)
                }
            }
          
        }else{
            formData.append('gallery', null)
        }


        const headers = {
            Authorization: "Bearer " + dataToken,
          };
          for (let entry of formData.entries()) {
        }
          const response = await instance.post(`/api/mgr/business/retail/directory`, formData, {
            headers: headers,
          });
           
          return response;
    } catch (error) {
        Swal.fire({
            icon: "error",
            title: error,
            confirmButtonText: "OK",
        }).then((result) => {});
    }
};

export const updateBusRetailDir = async (id, body) => {
    try {
        const formData = new FormData()
        formData.append('name_en', body.name_en)
        formData.append('name_th', body.name_th)
        formData.append('description_en', body.description_en)
        formData.append('description_th', body.description_th)
        formData.append('address_en', body.address_en)
        formData.append('address_th', body.address_th)
        formData.append('active', body.active)
        formData.append('room_no', body.room_no)
        formData.append('floor', body.floor)
        formData.append('open_time', body.open_time)
        formData.append('tel', body.tel)

        if (body.gallery.length > 0) {
            for(let i = 0; i < body.gallery.length; i++) {
                if(body.gallery[i].file?.file){
                    const blob = new Blob([body.gallery[i].file?.file], { type: body.gallery[i].file?.file.type });
                    const parts = body.gallery[i].file?.src[0].split('/')
                    const fileName = parts[parts.length - 1];
                    const currentTime = new Date();
                    const file = new File([blob], fileName, {
                        type: body.gallery[i].file?.file.type,
                        lastModified: currentTime.getTime(),
                        lastModifiedDate: currentTime,
                        size: body.gallery[i].file.size
                    });
    
                    formData.append('gallery', file)
                }else {
                    formData.append(`gallery`, body.gallery[i].file);
                }
            }
          
        }else{
            formData.append('gallery', null)
        }


        const headers = {
            Authorization: "Bearer " + dataToken,
        };
        const response = await instance.put(`/api/mgr/business/retail/directory/${id}`, formData, {
            headers: headers,
        });

        return response;

    } catch (error) {
        Swal.fire({
            icon: "error",
            title: error,
            confirmButtonText: "OK",
        }).then((result) => {});
    }
};

export const deleteBusRetailDir = async (id) => {
    try {
      const headers = {
        Authorization: "Bearer " + dataToken,
      };
      const response = await instance.delete(`/api/mgr/business/retail/directory/${id}`, {
        headers: headers,
      });
  
      if (response.status === 200) {
        return await response;
      } else {
        return null;
      }
    } catch (error) {
      Swal.fire({
        icon: "error",
        title: error,
        confirmButtonText: "OK",
      }).then((result) => {});
    }
};

// ----------------------------------------------- Condo----------------------------------------------------
export const getBusCondo = async () => {
    try{
        const headers = {
            Authorization: "Bearer " + dataToken,
          };
        const response = await instance.get(`/api/mgr/business/condo`, {
            headers:headers,
        })
        if (response.status === 200) {
            return response;
        } else {
            return null;
        }
    }catch(error) {
        Swal.fire({
            icon: "error",
            title: error,
            confirmButtonText: "OK",
        }).then((result) => {});
    }
};

export const getBusCodoByID = async (id) => {
    try {
        const headers = {
            Authorization: "Bearer " + dataToken,
        };
        const response = await instance.get(`/api/mgr/business/condo/${id}`, {
            headers: headers,
        });
        if (response.status === 200) {
            return await response;
        } else {
            return null;
        }
    } catch (error) {
        Swal.fire({
            icon: "error",
            title: error,
            confirmButtonText: "OK",
        }).then((result) => {});
    }
};

export const createAndUpdateBusCondoByID = async (id, body) => {
    try {
        const formData = new FormData()
        formData.append('vr_link', body.vr_link)
        formData.append('description_en', body.description_en)
        formData.append('description_th', body.description_th)
        formData.append('specification_en', body.specification_en)
        formData.append('specification_th', body.specification_th)
        formData.append('facilities_en', body.facilities_en)
        formData.append('facilities_th', body.facilities_th)
        formData.append('email_contact', body.email_contact)
        formData.append('email_cc', body.email_cc)
    
        if (body.spec_img.length > 0) {
            if(body.spec_img[0].file?.file){
                const blob = new Blob([body.spec_img[0].file?.file], { type: body.spec_img[0].file?.file.type });
                const parts = body.spec_img[0].file?.src[0].split('/')
                const fileName = parts[parts.length - 1];
                const currentTime = new Date();
                const file = new File([blob], fileName, {
                    type: body.spec_img[0].file?.file.type,
                    lastModified: currentTime.getTime(),
                    lastModifiedDate: currentTime,
                    size: body.spec_img[0].file.size
                });

                formData.append('spec_img', file)
            }
            else{
                formData.append('spec_img', body.spec_img[0].file)
            }
        }
        else{
            formData.append('spec_img', null)
        }

        if (body.fac_img.length > 0) {
            if(body.fac_img[0].file?.file){
                const blob = new Blob([body.fac_img[0].file?.file], { type: body.fac_img[0].file?.file.type });
                const parts = body.fac_img[0].file?.src[0].split('/')
                const fileName = parts[parts.length - 1];
                const currentTime = new Date();
                const file = new File([blob], fileName, {
                    type: body.fac_img[0].file?.file.type,
                    lastModified: currentTime.getTime(),
                    lastModifiedDate: currentTime,
                    size: body.fac_img[0].file.size
                });

                formData.append('fac_img', file)
            }
            else{
                formData.append('fac_img', body.fac_img[0].file)
            }
        }
        else{
            formData.append('fac_img', null)
        }

        if (body.gallery.length > 0) {
            body.gallery.forEach((galleryItem, index) => {
                if (galleryItem.file?.file) {
                    const blob = new Blob([galleryItem.file.file], { type: galleryItem.file.file.type });
                    const parts = galleryItem.file.src[0].split('/');
                    const fileName = parts[parts.length - 1];
                    const currentTime = new Date();
                    const file = new File([blob], fileName, {
                        type: galleryItem.file.file.type,
                        lastModified: currentTime.getTime(),
                        lastModifiedDate: currentTime,
                        size: galleryItem.file.size
                    });
        
                    formData.append(`gallery`, file);
                } else {
                    formData.append(`gallery`, galleryItem.file);
                }
            });
        }
        else{
            formData.append('gallery', null)
        }

        if (body.plan_img.length > 0) {
            body.plan_img.forEach((planItem, index) => {
                if (planItem.file?.file) {
                    const blob = new Blob([planItem.file.file], { type: planItem.file.file.type });
                    const parts = planItem.file.src[0].split('/');
                    const fileName = parts[parts.length - 1];
                    const currentTime = new Date();
                    const file = new File([blob], fileName, {
                        type: planItem.file.file.type,
                        lastModified: currentTime.getTime(),
                        lastModifiedDate: currentTime,
                        size: planItem.file.size
                    });
        
                    formData.append(`plan_img`, file);
                } else {
                    formData.append(`plan_img`, planItem.file);
                }
            });
        }
        else{
            formData.append('plan_img', null)
        }

        const headers = {
            Authorization: "Bearer " + dataToken,
        };
        let response = null 
        if(id){
            response = await instance.put(`/api/mgr/business/condo/${id}`, formData, {
                headers: headers,
            });
        }else{
            response = await instance.post(`/api/mgr/business/condo`, formData, {
                headers: headers,
            });
        }
        return response;

    } catch (error) {
        Swal.fire({
            icon: "error",
            title: error,
            confirmButtonText: "OK",
        }).then((result) => {});
    }
};

export const getBusCondoDetail = async (queryparams) => {
    try {
        const headers = {
            Authorization: "Bearer " + dataToken,
        };
        const response = await instance.get(`/api/mgr/business/condo/detail`, {
            headers: headers,
            params: {...queryparams}
        });
        if (response.status === 200) {
            return await response;
        } else {
            return null;
        }
    } catch (error) {
        Swal.fire({
            icon: "error",
            title: error,
            confirmButtonText: "OK",
        }).then((result) => {});
    }
};

export const createAndUpdateBusCondoDetail = async (id, body) => {
    try {
        const formData = new FormData()
        formData.append('type', body.type)
        formData.append('description_en', body.description_en)
        formData.append('description_th', body.description_th)
        formData.append('title1_room_en', body.title1_room_en)
        formData.append('title1_room_th', body.title1_room_th)
        formData.append('title2_room_en', body.title2_room_en)
        formData.append('title2_room_th', body.title2_room_th)
        formData.append('title3_room_en', body.title3_room_en)
        formData.append('title3_room_th', body.title3_room_th)
        formData.append('room1_description_en', body.room1_description_en)
        formData.append('room1_description_th', body.room1_description_th)
        formData.append('room2_description_en', body.room2_description_en)
        formData.append('room2_description_th', body.room2_description_th)
        formData.append('room3_description_en', body.room3_description_en)
        formData.append('room3_description_th', body.room3_description_th)

        if (body.room1_gallery.length > 0) {
            body.room1_gallery.forEach((room1Gallery, index) => {
                if (room1Gallery.file?.file) {
                    const blob = new Blob([room1Gallery.file.file], { type: room1Gallery.file.file.type });
                    const parts = room1Gallery.file.src[0].split('/');
                    const fileName = parts[parts.length - 1];
                    const currentTime = new Date();
                    const file = new File([blob], fileName, {
                        type: room1Gallery.file.file.type,
                        lastModified: currentTime.getTime(),
                        lastModifiedDate: currentTime,
                        size: room1Gallery.file.size
                    });
        
                    formData.append(`room1_gallery`, file);
                } else {
                    formData.append(`room1_gallery`, room1Gallery.file);
                }
            });
        }
        else{
            formData.append('room1_gallery', null)
        }
        if (body.room2_gallery.length > 0) {
            body.room2_gallery.forEach((room2Gallery, index) => {
                if (room2Gallery.file?.file) {
                    const blob = new Blob([room2Gallery.file.file], { type: room2Gallery.file.file.type });
                    const parts = room2Gallery.file.src[0].split('/');
                    const fileName = parts[parts.length - 1];
                    const currentTime = new Date();
                    const file = new File([blob], fileName, {
                        type: room2Gallery.file.file.type,
                        lastModified: currentTime.getTime(),
                        lastModifiedDate: currentTime,
                        size: room2Gallery.file.size
                    });
        
                    formData.append(`room2_gallery`, file);
                } else {
                    formData.append(`room2_gallery`, room2Gallery.file);
                }
            });
        }
        else{
            formData.append('room2_gallery', null)
        }
        if (body.room3_gallery.length > 0) {
            body.room3_gallery.forEach((room3Gallery, index) => {
                if (room3Gallery.file?.file) {
                    const blob = new Blob([room3Gallery.file.file], { type: room3Gallery.file.file.type });
                    const parts = room3Gallery.file.src[0].split('/');
                    const fileName = parts[parts.length - 1];
                    const currentTime = new Date();
                    const file = new File([blob], fileName, {
                        type: room3Gallery.file.file.type,
                        lastModified: currentTime.getTime(),
                        lastModifiedDate: currentTime,
                        size: room3Gallery.file.size
                    });
        
                    formData.append(`room3_gallery`, file);
                } else {
                    formData.append(`room3_gallery`, room3Gallery.file);
                }
            });
        }
        else{
            formData.append('room3_gallery', null)
        }

        const headers = {
            Authorization: "Bearer " + dataToken,
        };
        let response = null 
        if(id){
            response = await instance.put(`api/mgr/business/condo/detail/${id}`, formData, {
                headers: headers,
            });
        }else{
            response = await instance.post(`api/mgr/business/condo/detail`, formData, {
                headers: headers,
            });
        }
        return response;

    } catch (error) {
        Swal.fire({
            icon: "error",
            title: error,
            confirmButtonText: "OK",
        }).then((result) => {});
    }
};